import Vue from 'vue'
import BaseBtn from '@/components/Btn'
import BaseCard from '@/components/Basecard'
import BaseSubheading from '@/components/Subheading'

Vue.component(BaseBtn.name, BaseBtn)
Vue.component(BaseCard.name, BaseCard)
Vue.component(BaseSubheading.name, BaseSubheading)